const themeSliders = () => {
  $(() => {
    // Shop Page Header Slider
    const archiveHeader = document.getElementById("archiveHeader");
    if (archiveHeader) {
      const slider = new Swiper(archiveHeader, {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 4000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }

    // Single Product Header Slider
    const singleEventSliderNav = document.querySelector(".single-event-gallery-nav");
    const singleEventSliderBig = document.querySelector(".single-event-gallery-big");
    if (singleEventSliderNav && singleEventSliderBig) {
      const sliderNav = new Swiper(singleEventSliderNav, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          768: {
            direction: "vertical",
            spaceBetween: 0,
          },
        },
      });

      const sliderBig = new Swiper(singleEventSliderBig, {
        spaceBetween: 10,
        thumbs: {
          swiper: sliderNav,
        },
      });
    }

    // Single Product Multistep Checkout Calendar
    if ($(".calendar-frame")) {
      initProductPageCalendar($(".calendar-frame"));
    }
  });
};

export default themeSliders;

const initProductPageCalendar = ($selector) => {
  $selector.slick({
    dots: false,
    arrows: true,
    infinite: false,
    draggable: false,
  });
};
